// Code Generated by Sidekick is for learning and experimentation purposes only.
import React from "react";
import { color, courseDetails } from "../../../utils";
import { useNavigate } from "react-router-dom"; // <-- import useNavigate

function Category() {
  let count = 0;
  const navigate = useNavigate(); // <-- initialize navigate

  return (
    <section className="section category" aria-label="category" style={{ padding: "50px" }}>
      <div>
        <p className="section-subtitle">Popular Courses</p>
        <h2 className="h2 section-title">
          Pick A <span className="span">Course</span> To Get Started.
        </h2>
        <p className="section-text">
          Interactive lessons designed for anytime, anywhere learning.
        </p>
      </div>

      <ul className="grid-list">
        {courseDetails.map((_, i) => {
          if (_.isTopCourse) {
            count = count + 1;
            return (
              <li key={_.id || i}>
                <div
                  className="category-card card-with-badge"
                  style={{ "--color": color[count - 1], cursor: "pointer" }}
                  onClick={() => navigate(`/courses/${_.id}`)} // <-- make card clickable
                  tabIndex={0}
                  role="button"
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") navigate(`/courses/${_.id}`);
                  }}
                >
                  <div className="card-icon">
                    <img
                      src={_.thumbnail ? _.thumbnail : "/assets/images/category-1.svg"}
                      width="40"
                      height="40"
                      loading="lazy"
                      alt="Online Degree Programs"
                      className="img"
                    />
                  </div>
                  <h3 className="h3">
                    <span className="card-title">{_.title}</span>
                  </h3>
                  <p
                    className="card-text"
                    dangerouslySetInnerHTML={{
                      __html: _.description ? _.description.slice(0, 1000) + "..." : "",
                    }}
                  />
                  <span className="card-badge">Know More</span>
                </div>
              </li>
            );
          } else {
            return null;
          }
        })}
      </ul>
    </section>
  );
}

export default Category;
